import { P2Alert } from "react-bootstrap-common-script";
import { SolicitorNotificationStatusEnum } from "../../../../models/enum/solicitor-notification-status.enum";
import { useSolicitorCaseDetailsContext } from "../../../../context/solicitor-case-details-context";
import { useState } from "react";

export function SolicitorNotification() {
  const { solicitorCaseSummaryData, solicitorCaseSummaryIsFetching, solicitorNotificationData, solicitorNotificationIsFetching } =
    useSolicitorCaseDetailsContext();
  const [isShow, setIsShow] = useState<boolean>(true);

  if (solicitorCaseSummaryIsFetching || solicitorNotificationIsFetching) return null;

  switch (solicitorCaseSummaryData?.application_status) {
    case "APPLICATION_CANCELLED":
    case "CANCELLED": {
      return (
        <P2Alert
          variant="warning"
          title="Case is cancelled"
          text="This case has been cancelled. You may contact the applicants for further details. The case will be removed from the portal after 30 days."
          withBorder={true}
          isShow={isShow}
          style={{ marginBottom: 32 }}
        />
      );
    }

    case "REJECTED": {
      return (
        <P2Alert
          variant="danger"
          title="Case is rejected"
          text="This case has been reviewed and the application may not proceed. You may download the rejection letter from the case summary below. The case will be removed from the portal after 30 days."
          withBorder={true}
          isShow={isShow}
          style={{ marginBottom: 32 }}
        />
      );
    }
  }

  switch (solicitorNotificationData?.notification_status) {
    case SolicitorNotificationStatusEnum.case_received: {
      return (
        <P2Alert
          variant="info"
          title="New case received"
          text="View case updates and correspondences with HDB on this page."
          withBorder={true}
          withCloseIcon={true}
          isShow={isShow}
          onClose={() => {
            setIsShow(false);
          }}
          style={{ marginBottom: 32 }}
        />
      );
    }
    case SolicitorNotificationStatusEnum.ipa_received: {
      return (
        <P2Alert
          variant="info"
          title="In-principle approval received"
          text="This case has been reviewed and in-principle approval has been granted. You may download the IPA letter in the Case Summary below."
          withBorder={true}
          withCloseIcon={true}
          isShow={isShow}
          onClose={() => {
            setIsShow(false);
          }}
          style={{ marginBottom: 32 }}
        />
      );
    }
    case SolicitorNotificationStatusEnum.removed: {
      return (
        <P2Alert
          variant="danger"
          title="Your client has changed the solicitor representation"
          text="You no longer have access to the case since you are not representing your client anymore. This case will be kept in this portal for 30 days and you will no longer be able to receive anymore updates regarding this case."
          withBorder={true}
          isShow={isShow}
          style={{ marginBottom: 100 }}
        />
      );
    }
    case SolicitorNotificationStatusEnum.no_action: {
      return null;
    }
    default: {
      return null;
    }
  }
}
